module.exports = __webpack_public_path__ + "img/is_use_txt.48cd49a2.png";